import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';

import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';

import {UiIconModule} from '../icon/icon.module';

import {
  UIDatePickerModule,
  UIDatePickerNumberModule,
  UIDatePickerDateModule,
  UIDatePickerMomentModule,
  UIDatePickerStringModule
} from '../date-picker/date-picker.module';
import {DateTimePickerComponent} from './date-time-picker.component';
import {UITimePickerModule} from '../time-picker/time-picker.module';

@NgModule({
  declarations: [DateTimePickerComponent],
  imports: [
    CommonModule,
    UiIconModule,
    UIDatePickerModule,
    UIDatePickerNumberModule,
    UIDatePickerDateModule,
    UIDatePickerMomentModule,
    UIDatePickerStringModule,
    UITimePickerModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDropdownModule
  ],
  exports: [
    UIDatePickerModule,
    UIDatePickerNumberModule,
    UIDatePickerDateModule,
    UIDatePickerMomentModule,
    UIDatePickerStringModule,
    UITimePickerModule,
    DateTimePickerComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class DateTimePickerModule {
}
